import React from "react";
import { ConfirmModal } from "../ConfirmModal";
import { ActivateScheduleModalProps } from "./ActivateScheduleModal.types";

const buildScheduleInfo = (name?: string, time?: string) => {
  if (!name && !time) return undefined;
  return (
    <>
      Current active schedule:{" "}
      {name ? <strong>{name}</strong> : null}
      {name && time ? " • " : null}
      {time}
    </>
  );
};

export const ActivateScheduleModal = ({
  open,
  isLoading = false,
  currentScheduleName,
  currentScheduleTime,
  onConfirm,
  onCancel,
}: ActivateScheduleModalProps) => {
  return (
    <ConfirmModal
      open={open}
      isLoading={isLoading}
      title="Activate schedule?"
      description="Only one active schedule is allowed for the dataset. Activating this will pause the currently active schedule."
      infoText={buildScheduleInfo(currentScheduleName, currentScheduleTime)}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmLabel="Activate"
      cancelLabel="Cancel"
      confirmVariant="primary"
    />
  );
};
